module.exports = __webpack_public_path__ + "static/img/pic6-2.775ffa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/pic6-2.jpg
// module id = yC4R
// module chunks = 1